let index: number = 0;

const GoodsSubstanceGridPluginSettingsForMovement: IPluginSettings = {
    name: 'Номенклатура',
    mnemocode: 'goods_substance_plugin_for_movement',
    permission: 'Goods',
    columns: [{
        order: index++,
        propertyName: 'substanceName',
        propertyType: 'string',
        displayName: 'МНН',
        visibility: true,
        favoriteFilter: true,
        width: 150
    }, {
        order: index++,
        propertyName: 'important',
        propertyType: 'boolean',
        displayName: 'ЖНВЛП',
        visibility: true,
        favoriteFilter: true,
        width: 150
    }, {
        order: index++,
        propertyName: 'isLs',
        propertyType: 'boolean',
        displayName: 'Лек. средство',
        visibility: true,
        favoriteFilter: false,
        width: 150
    }, {
        order: index++,
        propertyName: 'isPrescription',
        propertyType: 'boolean',
        displayName: 'Рецептурный',
        visibility: true,
        favoriteFilter: false,
        width: 150
    }],
}

export default GoodsSubstanceGridPluginSettingsForMovement